import { React, useEffect } from "react";
import { FaDownload, FaGraduationCap, FaLaptopCode } from "react-icons/fa";
import htmlIcon from "../assets/html.png";
import cssIcon from "../assets/css.png";
import gbIcon from "../assets/gb.jpg";
import javascriptIcon from "../assets/javascript.png";
import resume from "../assets/resume-sureka-2025.pdf";
import cIcon from "../assets/c.png";
import cppIcon from "../assets/cpp.png";
import uiuxIcon from "../assets/uiux.png";
import javaIcon from "../assets/java.png";
import pythonIcon from "../assets/python.png";
import MySQLicon from "../assets/mysql.png";

function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="about">
        <h1 className="heading">
          {" "}
          About <span> Me </span>{" "}
        </h1>
        <div className="row">
          <div className="info-container">
            <h1> personal Info </h1>
            <div className="box-container">
              <div className="box">
                <h3>
                  {" "}
                  <span> Name : </span> SUREKA{" "}
                </h3>
                <h3>
                  {" "}
                  <span> Age : </span> 20{" "}
                </h3>
                <h3>
                  {" "}
                  <span> Email : </span> surekakumar8@gmail.com
                </h3>
                <h3>
                  {" "}
                  <span> Address : </span>
                  113/49,North Street,Thirubuvanam, Thanjavur-612103.{" "}
                </h3>
              </div>
              <div className="box">
                <h3>
                  {" "}
                  <span> Skill : </span> Full-Stack Developer{" "}
                </h3>
                <h3>
                  {" "}
                  <span> Language : </span>English,Tamil{" "}
                </h3>
              </div>
            </div>
            <div className="aboutMeBtn">
            <a
                href={resume}
                download="Surekaresume"
                target=" _blank"
                className="btnAbout"
                >
                            
                Download CV{" "}
                <span>
                  {" "}
                  <FaDownload className="downloadBtnIcon" />{" "}
                </span>{" "}
              </a>
            </div>
          </div>
          <div className="count-container">
            {/* <div className="box">
              <h3> 6 </h3>
              <p> Months Of Work Experience </p>
            </div> */}

            <div className="box">
              <p> TECHNOHACKS-C PROGRAMMING-INTERNSHIP </p>
            </div>
            <div className="box">
              <p> ONGING  </p>
              <p>COGNIFYZ-FRONTEND DEVELOPER-INTERNSHIP</p>
            </div>
            <div className="box">
              <p> PERSONAL-EXPENSE-TRACKER-PROJECT </p>
            </div>

            <div className="box">
              <h3> 74 % </h3>
              <p> Percentage Scored in SASTRA Deemed To Be University </p>
            </div>
          </div>
        </div>
      </section>

      <section className="skills">
        <h1 className="heading">
          {" "}
          <span> My </span> Skills{" "}
        </h1>
        <div className="box-container">
          <div className="box">
            <img src={htmlIcon} alt="htmlIcon" loading="lazy" />
            <h3> html </h3>
          </div>
          <div className="box">
            <img src={cssIcon} alt="cssIcon" loading="lazy" />
            <h3> css </h3>
          </div>
          <div className="box">
            <img src={javaIcon} alt="javaIcon" loading="lazy" />
            <h3> Java </h3>
          </div>
          <div className="box">
            <img src={pythonIcon} alt="PythonIcon" loading="lazy" />
            <h3> Python </h3>
          </div>
          <div className="box">
            <img src={javascriptIcon} alt="javascriptIcon" loading="lazy" />
            <h3> javascript </h3>
          </div>
          <div className="box">
            <img src={cIcon} alt="cIcon" loading="lazy" />
            <h3> C </h3>
          </div>
          <div className="box">
            <img src={cppIcon} alt="cppIcon" loading="lazy" />
            <h3> Cpp</h3>
          </div>
          <div className="box">
            <img src={uiuxIcon} alt="uiuxIcon" loading="lazy" />
            <h3> UI/UX </h3>
          </div>
          <div className="box">
            <img src={MySQLicon} alt="MySQLicon" loading="lazy" />
            <h3> MySQL </h3>
          </div>
          <div className="box">
            <img src={gbIcon} alt="htmlIcon" loading="lazy" />
            <h3> GitHub </h3>
          </div>
        </div>
      </section>

      <section className="education">
        <h1 className="heading">
          <span> my </span> education{" "}
        </h1>
        <div className="box-container">
          <div className="box">
            <i>
              {" "}
              <FaGraduationCap />{" "}
            </i>
            <span>Jun 2019 - Mar 2020 </span>
            <h3> SSLC </h3>
            <p>
              {" "}
              I scored 91% in the State Board Tamil Medium from Government
              Higher Secondary School, Thirubuvanam - 612103.{" "}
            </p>
          </div>

          <div className="box">
            <i>
              {" "}
              <FaGraduationCap />{" "}
            </i>
            <span> Jun 2021 - Mar 2022 </span>
            <h3> HSC </h3>
            <p>
              {" "}
              I scored 79.8% in the State Board Tamil Medium from Government
              Higher Secondary School, Thirubuvanam - 612103.
            </p>
          </div>

          <div className="box">
            <i>
              {" "}
              <FaLaptopCode />{" "}
            </i>
            <span> Sep 2022 - May 2025 </span>
            <h3> BCA(Bachelor Of Computer Application) </h3>
            <p>
              {" "}
I scored 7.42 CGPA at SASTRA Deemed to be University, Kumbakonam{" "}
            </p>
          </div>
        </div>
      </section>

      {/* <section className="education">
        <h1 className="heading">
          <span> my </span> Work Experience{" "}
        </h1>
        <div className="box-container">
          <div className="box">
            <i>
              {" "}
              <FaLaptopCode />{" "}
            </i>
            <span> Jul 2024 - Dec 2024 </span>
            <h3>Smartweb Technologies | Full Stack Developer (6 months) </h3>
            <p>
              {" "}
              <em>
                AI Companion: Secure Access & Subscription Manager | Coimbatore,
                India
              </em>{" "}
            </p>
            <p>
              {" "}
              Frontend: Built responsive interfaces with React, Bootstrap, and JavaScript. Implemented dynamic state management with React Hooks and a validated file upload feature.{" "}
            </p>
            <p>
              {" "}
              Backend: Developed a secure Node.js and Express.js backend with
              JWT authentication, bcrypt encryption, and dynamic subscription
              management using MongoDB.{" "}
            </p>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default About;
